import { Headline } from '@almbrand/headline';
import { Modal } from '@almbrand/modal';
import { RichText } from '@almbrand/richtext';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { setModal } from 'store/slices/modalSlice';
import styles from './ModalComponent.module.scss';

export const ModalComponent = () => {
	const dispatch = useAppDispatch();
	const { displayModal, modalProps } = useAppSelector((state) => state.modal);

	if (!displayModal || !modalProps) return null;

	const handleClose = () => dispatch(setModal({ displayModal: false }));

	return (
		<Modal
			mode='default'
			mobileVariation='fullWidth'
			{...modalProps}
			handleClose={handleClose}
		>
			{
				<div className={styles.ModalComponent}>
					{modalProps.subtitle && (
						<div className={styles.ModalComponent__headline}>
							<Headline
								fontColor='primary'
								size='default'
								title={modalProps.subtitle}
								variant='h2'
							/>
						</div>
					)}
					<RichText
						description={modalProps.content}
						className={
							(modalProps.className, modalProps.isErrorModal ? styles.ModalComponent__error : undefined)
						}
					/>
					{modalProps.fields?.map((field, idx) => <div key={idx + '_'}>{field}</div>)}
				</div>
			}
		</Modal>
	);
};
